import { inject, NgZone } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, forkJoin, EMPTY, of, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IsidePast } from '../../../models/iside-past';
import { IyearPast } from '../../../models/iyear-past';
import { AlertMessageService } from '../alert-msg/message.service';

export const pastpapersDetailsResolver: ResolveFn<any> = (route, state) => {
  const subTopic_slug = route.paramMap.get('subTopic'); 
  const cur_slug = route.queryParamMap.get('cur_slug');
  const numOfYear = route.queryParamMap.get('year');

  const _httpClient = inject(HttpClient);
  const _alertMessageService = inject(AlertMessageService);
  const zone = inject(NgZone);

  const baseUrl = environment.apiUrl;

  const handleError = (defaultMsg: string) => (err: any) => {
    zone.run(() => {
      _alertMessageService.addMsg(err?.error?.msg || defaultMsg);
    });
    return EMPTY;
  };

  const sidebarRequest = _httpClient
    .get<IsidePast>(`${baseUrl}api/website/topics/${subTopic_slug}/pastpapers/sidebar?curriclum_slug=${cur_slug}`)
    .pipe(catchError(handleError('Error loading sidebar data')));

  if (!numOfYear) {
    return sidebarRequest.pipe(
      switchMap((sidebarData: any) => {
        const firstYear = sidebarData?.data?.[0];
        return forkJoin({
          sidebar: of(sidebarData),
          subTopics: _httpClient
            .get<IyearPast>(`${baseUrl}api/website/topics/${subTopic_slug}/pastpapers/${firstYear}?curriclum_slug=${cur_slug}`)
            .pipe(catchError(handleError('Error loading subTopics data')))
        });
      }),
      catchError(handleError('Error loading data')) 
    );
  } else {
    const subTopicsRequest = _httpClient
      .get<IyearPast>(`${baseUrl}api/website/topics/${subTopic_slug}/pastpapers/${numOfYear}?curriclum_slug=${cur_slug}`)
      .pipe(catchError(handleError('Error loading subTopics data')));

    return forkJoin({
      sidebar: sidebarRequest,
      subTopics: subTopicsRequest
    }).pipe(catchError(handleError('Error loading data')));
  }
};
